class EnvironmentUtils {
    static readonly GATSBY_NOBLE_ENV = process.env.GATSBY_NOBLE_ENV as string;
    static readonly GATSBY_APP_URL = process.env.GATSBY_APP_URL as string;
    static readonly GATSBY_API_URL = process.env.GATSBY_API_URL as string;
    static readonly GATSBY_INTERCOM_APP_ID = process.env.GATSBY_INTERCOM_APP_ID as string;
    static readonly GATSBY_KNOWLEDGE_URL = process.env.GATSBY_KNOWLEDGE_URL as string;

    static get isDev(): boolean {
        return this.GATSBY_NOBLE_ENV === 'development';
    }

    static get isProd(): boolean {
        return this.GATSBY_NOBLE_ENV === 'production';
    }
}

export default EnvironmentUtils;
